import { Component, OnInit, TemplateRef } from '@angular/core';
import { LatestOffer } from 'src/app/_models/latestOffers.model';
import { LatestOffersService } from 'src/app/_services/latest-offers.service';
import { environment, baseUrl } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { DeleteModalComponent } from 'src/app/components/delete-modal/delete-modal.component';
import { sortTable } from 'src/app/helpers/sort-table';

@Component({
  selector: 'app-latest-offers',
  templateUrl: './latest-offers.component.html',
  styleUrls: ['./latest-offers.component.scss'],
})
export class LatestOffersComponent implements OnInit {
  pageTitle: string = 'Latest Offers';
  placeholder: string = 'Search by offer name …';
  latestOffersArray: LatestOffer[] = [];
  filteredLatestOffersArray: LatestOffer[] = [];
  invertSort: boolean = false;
  theadArray = [
    'Offer Name',
    'Offer Rank',
    'Offer Route Name',
    'Offer From',
    'Offer To',
    'Offer Actions',
  ];

  modalRef: BsModalRef;

  constructor(
    private latestOffersService: LatestOffersService,
    public toastr: ToastrService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.getAllOffers();
  }

  getAllOffers() {
    this.latestOffersService.getAllOffers().subscribe((res) => {
      res?.data?.latestOffers.map((offer) => {
        offer.picture = `${offer.picture}`;
        this.latestOffersArray.push(offer);
      });

      this.filteredLatestOffersArray = [...this.latestOffersArray];
    });
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredLatestOffersArray = sortTable(
      this.filteredLatestOffersArray,
      'startDate',
      this.invertSort
    );
  }

  onSearchOffer(searchString) {
    this.latestOffersService
      .searchByName(searchString)
      .subscribe((response) => {
        this.filteredLatestOffersArray = response['data'];
      });
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredLatestOffersArray = [...this.latestOffersArray];
    }
  }

  onDeleteOffer(item): void {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.name,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteOfferSubmit(data);
    });
  }

  onDeleteOfferSubmit(offerId) {
    this.latestOffersService.deleteOffer(offerId).subscribe((res) => {
      showNotification(
        'success',
        `${res.data.name} has been deleted`,
        this.toastr
      );

      this.latestOffersArray = this.latestOffersArray.filter(
        (offer) => offer.id !== offerId
      );

      this.filteredLatestOffersArray = [...this.latestOffersArray];

      this.modalRef.hide();
    });
  }
}
